import basicRest from '../common/CommonRestFunctions'

const baseOutcomeUrl = '/outcome'

export default {
  getOutcomes () {
    return basicRest.executeBasicAxiosGet(baseOutcomeUrl + '/list')
  },
  saveOutcome (outcomeInfo) {
    return basicRest.executeBasicAxiosPost(baseOutcomeUrl + '/save', outcomeInfo)
  },
  filterOutcomes (filters) {
    return basicRest.executeBasicAxiosPost(baseOutcomeUrl + '/filter', filters)
  }
}
